import { render } from "./ReceptionistDashboardPage.vue?vue&type=template&id=650ac10c"
import script from "./ReceptionistDashboardPage.vue?vue&type=script&lang=js"
export * from "./ReceptionistDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__